import {Button} from "primereact/button";
import {Slot} from "../../data/Slot";
import {Toast} from "primereact/toast";
import {useRef} from "react";

function ExportPanel({slots}: { slots: Slot[] | null; }) {
    async function syncExporter() {
        await fetch(`/api/exporter/sync`, {
            method: "POST",
            credentials: "include",
        });
        exporterTriggered()
    }

    function getText(): string {
        if (!slots || slots.length === 0) return "";

        const weekdayFormatter = new Intl.DateTimeFormat("de-DE", {weekday: "short"});
        const dayFormatter = new Intl.DateTimeFormat("de-DE", {day: "2-digit", month: "2-digit"});
        const timeFormatter = new Intl.DateTimeFormat("de-DE", {hour: "2-digit", minute: "2-digit"});
        const monthFormatter = new Intl.DateTimeFormat("de-DE", {month: "long"});

        const startOfToday = new Date();
        startOfToday.setHours(0, 0, 0, 0);

        // Group by year+month, keep chronological order
        const byMonth = new Map<string, { label: string; slots: Slot[] }>();
        const sorted = [...slots]
            .filter(slot => new Date(slot.endDateTime).getTime() >= startOfToday.getTime())
            .sort((a, b) =>
                new Date(a.startDateTime).getTime() - new Date(b.startDateTime).getTime()
            );

        for (const slot of sorted) {
            const start = new Date(slot.startDateTime);
            const key = `${start.getFullYear()}-${start.getMonth()}`;
            if (!byMonth.has(key)) {
                byMonth.set(key, {label: monthFormatter.format(start), slots: []});
            }
            byMonth.get(key)!.slots.push(slot);
        }

        const lines: string[] = [];
        for (const {label, slots: monthSlots} of byMonth.values()) {
            lines.push(`*${label}:*`);
            for (const slot of monthSlots) {
                const start = new Date(slot.startDateTime);
                const end = new Date(slot.endDateTime);
                lines.push(
                    `${weekdayFormatter.format(start)} ${dayFormatter.format(start)}: ` +
                    `${timeFormatter.format(start)}-${timeFormatter.format(end)}`
                );
            }
            lines.push("");
        }
        return lines.join("\n").trimEnd();
    }

    const toast = useRef<Toast>(null);

    const exporterTriggered = () => {
        toast.current!.show({
            severity: "success",
            summary: "Exportiert",
            detail: "Exporter erfolgreich angestoßen!",
        });
    };

    const showClipboard = () => {
        toast.current!.show({
            severity: "success",
            summary: "Kopiert",
            detail: "Termine in Zwischenablage kopiert!",
        });
    };

    return (
        <div style={{
            display: "flex",
            flexDirection: "column",
            gap: "0.5rem",
            maxWidth: "800px",
            margin: "0 auto",
            padding: "1rem",
            boxSizing: "border-box",
        }}>
            <Toast ref={toast}/>

            <Button label="Exporter synchronisieren" onClick={syncExporter}/>
            <Button label="Kommende Termine in die Zwischenablage" onClick={async () => {
                const text = getText();

                if (navigator.clipboard?.writeText) {
                    try {
                        await navigator.clipboard.writeText(text);
                        showClipboard();
                    } catch {
                    }
                }

            }}/>
        </div>
    );
}

export default ExportPanel;
